<div class="error-container">
  <h1>Oops! An Error Occurred</h1>
  <p>We're sorry, but something went wrong. Please try again later.</p>
  <button (click)="navigateToHome()">Go to Home</button>
</div>
